import View from "backdraft-app/src/view";

import _ from "underscore";
import $ from "jquery";

import { bindMessageToFormField } from "./stickit_helpers";

import Invoca from "shared/invoca";

import Flash from "shared/flash";
import Ajax from "shared/ajax";

class Form extends View {
  constructor(...args) {
    super(...args);

    this.formBindings = [];

    this.listenTo(this.model, "change:errors", model => {
      if (model.get('errors')) {
        // ensure UI has had time to update
        setTimeout(() => {
          // ensure errors are visible in viewport

          // Prefer sb-field-group--invalid over deprecated has-error
          const firstError = $('.sb-field-group--invalid:first') || $('.has-error:first');

          Invoca.smoothScrollTo(firstError.parent());
        }, 10);
      }
    });

    if (this.warnOnExit) {
      this._initModelAttributeTracking();
    }

    // allow other views to trigger an event to submit the form (if the buttons are rendered by a parent view for instance)
    this.on("action:save", this._onFormSubmit.bind(this));
  }

  bindErrorsToFormField(name, attr, options) {
    return this.bindMessageToFormField("error", name, attr, options);
  }

  bindWarningsToFormField(name, attr, options) {
    return this.bindMessageToFormField("warning", name, attr, options);
  }

  bindMessageToFormField(type, name, attr, options) {
    if (this.formBindings.indexOf(attr) === -1) {
      this.formBindings.push(attr);
    }

    return bindMessageToFormField(type, name, attr, options);
  }

  render() {
    this._renderForm();
    return this;
  }

  _renderForm() {
    this.$el.html(this.template({ isNew: this.model.isNew() }));
    this.stickit();
  }

  _onFormCancel() {
    this.trigger("cancel");
    return false;
  }

  _onFormSubmit() {
    this.trigger("beforeSubmit");

    this.$(".panel-footer .btn").prop("disabled", true);

    this.model.unset("errors");
    this.model.unset("warnings");

    const isValid = this.model.save(this._additionalAttributesToSave(), {
      wait: true,
      complete: () => {
        this.$(".panel-footer .btn").prop("disabled", false);
        this.trigger("afterSubmit");
      },
      success: model => {
        this.trigger("beforeSuccess", model);
        this._setModelAttrsToTrack();
        this.trigger("success");
      },
      error: (model, response, options) => {
        if (response.status === 403 || response.status === 422) {
          const unboundErrors = _.omit(response.responseJSON.errors, this._getFormBindings());
          this.model.set('errors', response.responseJSON.errors);

          if (!_.isEmpty(unboundErrors)) {
            Flash.showError(Ajax.parseErrorMessages(unboundErrors).join("<br/>"));
          }
        } else {
          const parsedResponse = Ajax.parseResponse(response);
          Flash.showError(parsedResponse.message);
        }
        this.trigger("afterError", model);
      }
    });

    // ensure button doesn't stay disabled if client-side validation ran and prevented the save callback entirely
    if (!isValid) {
      this.$(".panel-footer .btn").prop("disabled", false);
    }

    return false;
  }

  _getFormBindings() {
    return this.formBindings;
  }

  // override this method in order to pass additional attributes to this.model.save when submitting form
  _additionalAttributesToSave() {
    return {};
  }

  _initModelAttributeTracking() {
    if (this.model.fetching) {
      this.model.once("sync", this._setModelAttrsToTrack.bind(this));
    } else {
      this._setModelAttrsToTrack();
    }

    this._wireModelChangesToWarnOnExit();
  }

  _setModelAttrsToTrack() {
    this.trackedModelAttrs = _.pick(this.model.attributes, this._modelAttrsToTrackKeys());
  }

  _modelAttrsToTrackKeys() {
    if (_.isArray(this.warnOnExit)) {
      return _.intersection(this.warnOnExit, _.keys(this.model.attributes));
    } else {
      return _.keys(this.model.attributes);
    }
  }

  _wireModelChangesToWarnOnExit() {
    window.onbeforeunload = () => {
      if (this._modelHasChangedAttributes()) {
        return true;
      }
      return null;
    };
  }

  _modelHasChangedAttributes() {
    return !_.isEqual(this.trackedModelAttrs, _.pick(this.model.attributes, this._modelAttrsToTrackKeys()));
  }
}

/** @type {(boolean|Array.)}
 * Override this property in a child class if you want the browser window.onbeforeunload event
 * to be triggered by changes to the model.
 *
 * Passing a boolean will track all of the model's attributes to be checked. An array will only look for changes
 * to attributes that match one of the attribute names in the array.
 */
Form.prototype.warnOnExit = false;

Form.prototype.events = {
  "click .form-action-apply": "_onFormSubmit",
  "click .form-action-cancel": "_onFormCancel"
};

export default Form;
